export default {
  // Navigation
  nav_home: 'Главная',
  nav_dashboard: 'Панель управления',
  nav_orders: 'Заказы',
  nav_wallet: 'Кошелек',
  nav_analytics: 'Аналитика',
  nav_referral: 'Рефералы',
  nav_account: 'Аккаунт',
  nav_notifications: 'Уведомления',
  nav_logout: 'Выйти',
  nav_login: 'Войти',
  nav_signup: 'Регистрация',
  nav_deposit_requests: 'Запросы на депозит',
  nav_withdraw_requests: 'Запросы на вывод',
  nav_support_ticket: 'Тикет поддержки',
  nav_system_logs: 'Системный журнал',
  nav_announcements: 'Объявления',
  nav_activity_logs: 'Журнал активности',
  nav_settings: 'Настройки',
  nav_section_main: 'Главное',
  nav_user_active: 'В сети',
  nav_more: 'Еще',
  nav_logout_confirm: 'Вы уверены, что хотите выйти?',
  nav_language: 'Язык',

  // Dashboard
  dashboard_welcome: 'С возвращением',
  dashboard_total_earnings: 'Общий доход',
  dashboard_pending_orders: 'Ожидающие заказы',
  dashboard_completed_orders: 'Завершенные заказы',
  dashboard_commission_rate: 'Комиссионная ставка',
  dashboard_quick_actions: 'Быстрые действия',
  dashboard_recent_orders: 'Последние заказы',
  dashboard_recent_activity: 'Последняя активность',
  dashboard_wallet_balance: 'Баланс кошелька',
  dashboard_deposit: 'Депозит',
  dashboard_withdraw: 'Вывод',
  dashboard_view_all: 'Посмотреть все',
  greeting_morning: 'Доброе утро',
  greeting_afternoon: 'Добрый день',
  greeting_evening: 'Добрый вечер',
  dashboard_greeting_desc: 'Отслеживайте свои доходы, выполняйте заказы и управляйте своим аккаунтом в одном месте. Ваш путь к успеху продолжается здесь!',

  // Dashboard Stats
  stats_available_balance: 'Доступный баланс',
  stats_total_withdrawn: 'Всего выведено',
  stats_total_deposit: 'Всего пополнено',
  stats_pending_orders: 'Ожидающие заказы',
  stats_orders_suffix: ' заказов',
  stats_task_earnings: 'Доход от заданий',
  stats_lifetime_earning: 'Общий доход за все время',

  // Orders
  orders_title: 'Мои заказы',
  orders_all: 'Все заказы',
  orders_pending: 'Ожидает',
  orders_completed: 'Завершено',
  orders_cancelled: 'Отменено',
  orders_order_id: 'ID заказа',
  orders_platform: 'Платформа',
  orders_amount: 'Сумма',
  orders_commission: 'Комиссия',
  orders_status: 'Статус',
  orders_date: 'Дата',
  orders_no_orders: 'Заказы не найдены',
  orders_step_1: 'Проверка деталей продукта',
  orders_step_2: 'Проверка информации о заказе',
  orders_step_3: 'Подключение к платформе',
  orders_step_4: 'Отправка промоакции',
  orders_step_5: 'SEO-индексация',
  orders_step_6: 'Повышение видимости',
  orders_step_7: 'Завершение и подтверждение',
  orders_btn_optimize: 'Оптимизировать заказ',
  orders_btn_claim_commission: 'Получить комиссию',
  orders_btn_task_completed: 'Задание выполнено',
  orders_price_label: 'Цена заказа',
  orders_commission_rate_label: 'Комиссионная ставка',

  // Wallet
  wallet_title: 'Мой кошелек',
  wallet_available_balance: 'Доступный баланс',
  wallet_pending_balance: 'Ожидающий баланс',
  wallet_total_withdrawn: 'Всего выведено',
  wallet_deposit_now: 'Пополнить сейчас',
  wallet_withdraw_now: 'Вывести сейчас',
  wallet_transaction_history: 'История транзакций',
  wallet_deposit_history: "Deposit History",
  wallet_withdrawal_history: 'История выводов',
  wallet_deposit_desc: "Добавьте деньги в кошелек с помощью доступных способов оплаты.",
  wallet_no_deposits: "Пополнений не найдено.",
  wallet_withdraw_history: "История вывода",
  wallet_withdraw_desc: "Выведите деньги из кошелька.",
  wallet_no_withdrawals: "Выводов не найдено.",
  wallet_no_withdrawals_desc: "Вы еще не совершали выводов.",
  withdrawal_restricted_title: 'Вывод средств ограничен',
  withdrawal_restricted_message: 'В настоящее время вывод средств недоступен для вашей учетной записи. Пожалуйста, свяжитесь со службой поддержки для получения дополнительной информации.',
  // Analytics
  analytics_title: 'Аналитика',
  analytics_earnings_overview: 'Обзор доходов',
  analytics_platform_breakdown: 'Разбивка по платформам',
  analytics_performance_metrics: 'Показатели эффективности',
  analytics_top_products: 'Лучшие продукты',
  analytics_this_month: 'В этом месяце',
  analytics_last_month: 'В прошлом месяце',
  analytics_total_revenue: 'Общий доход',
  analytics_avg_order_value: 'Средний чек заказа',

  // Referral
  referral_title: 'Реферальная программа',
  referral_your_code: 'Ваш реферальный код',
  referral_copy_code: 'Копировать код',
  referral_share_link: 'Поделиться ссылкой',
  referral_total_referrals: 'Всего рефералов',
  referral_active_referrals: 'Активные рефералы',
  referral_referral_earnings: 'Доход от рефералов',
  referral_invite_friends: 'Пригласить друзей',

  // Account
  account_title: 'Настройки аккаунта',
  account_profile: 'Профиль',
  account_security: 'Безопасность',
  account_notifications: 'Уведомления',
  account_kyc: 'Верификация KYC',
  account_phone: 'Номер телефона',
  account_two_factor: 'Двухфакторная аутентификация',
  account_save_changes: 'Сохранить изменения',
  account_cancel: 'Отмена',

  // Auth & Common
  auth_email: 'Электронная почта',
  auth_password: 'Пароль',
  auth_confirm_password: 'Подтвердите пароль',
  auth_forgot_password: 'Забыли пароль?',
  auth_remember_me: 'Запомнить меня',
  auth_login_button: 'Войти',
  auth_signup_button: 'Зарегистрироваться',
  auth_already_have_account: 'Уже есть аккаунт?',
  auth_dont_have_account: "Нет аккаунта?",
  auth_reset_password: 'Сброс пароля',
  auth_verify_email: 'Подтвердить почту',
  auth_live_platform: 'Живая платформа',
  auth_security_verification: 'Проверка безопасности',
  auth_captcha_refresh: 'Обновить',
  auth_captcha_placeholder: 'Результат',
  auth_captcha_error: 'Неверная сумма, попробуйте еще раз',
  auth_branding_title: 'Превратите продвижение в',
  auth_branding_highlight_prefix: '',
  auth_branding_highlight: 'Реальный доход',
  auth_branding_desc: 'Присоединяйтесь к тысячам промоутеров, зарабатывающих ежедневные комиссии от ведущих мировых брендов электронной коммерции.',
  auth_sign_in_to_account: 'Войдите в свой аккаунт {{system_name}}',
  auth_email_placeholder: 'you@example.com',
  auth_password_placeholder: 'Введите ваш пароль',
  auth_signing_in: 'Вход...',
  auth_free_to_join: 'Присоединиться бесплатно',
  auth_signup_branding_title: 'Начните зарабатывать',
  auth_signup_branding_highlight: 'С первого дня',
  auth_signup_branding_desc: 'Опыт не требуется. Зарегистрируйтесь за 2 минуты и начните выполнять задания для ведущих брендов электронной коммерции.',
  auth_how_it_works: 'Как это работает',
  auth_signup_desc: 'Присоединяйтесь к {{system_name}} и начните зарабатывать комиссионные уже сегодня — это бесплатно!',
  auth_step_1: 'Создайте бесплатный аккаунт',
  auth_step_2: 'Просматривайте и принимайте задания',
  auth_step_3: 'Выполняйте и зарабатывайте комиссионные',
  auth_signup_step_1_title: 'Создать аккаунт',
  auth_signup_step_1_desc: 'Начните свое путешествие',
  auth_signup_step_2_title: 'Выполнять задания',
  auth_signup_step_2_desc: 'Зарабатывайте ежедневные комиссии',
  auth_signup_step_3_title: 'Вывод средств',
  auth_signup_step_3_desc: 'Быстрые и безопасные выплаты',
  auth_benefit_1_title: 'Безопасно и надежно',
  auth_benefit_1_desc: 'Безопасность банковского уровня для ваших доходов',
  auth_benefit_2_title: 'Мгновенные выплаты',
  auth_benefit_2_desc: 'Выводите заработанное в течение 24 часов',
  auth_benefit_3_title: 'Глобальное сообщество',
  auth_benefit_3_desc: 'Присоединяйтесь к 12 000+ активных промоутеров',
  auth_benefit_4_title: 'Поддержка 24/7',
  auth_benefit_4_desc: 'Получайте помощь в любое время',
  auth_strength_weak: 'Слабый',
  auth_strength_fair: 'Средний',
  auth_strength_good: 'Хороший',
  auth_strength_strong: 'Сильный',
  auth_password_strength: 'Сложность пароля: {{strength}}',
  auth_social_proof: 'Присоединяйтесь к {{count}}+ зарабатывающим',
  auth_passwords_match: 'Пароли совпадают',
  auth_creating_account: 'Создание аккаунта...',
  auth_phone_number: 'Номер телефона',
  auth_phone_optional: '(необязательно)',
  auth_phone_placeholder: 'Ваш номер телефона',
  auth_full_name: 'Полное имя',
  auth_full_name_placeholder: 'Иван Иванов',
  auth_password_min_chars: 'Минимум 8 символов',
  auth_confirm_password_placeholder: 'Повторите пароль',
  auth_agree_to: 'Я согласен с',
  auth_terms_of_service: 'Условиями обслуживания',
  auth_privacy_policy: 'Политикой конфиденциальности',
  auth_and: 'и',
  auth_create_free_account: 'Создать бесплатный аккаунт',

  common_loading: 'Загрузка...',
  common_save: 'Сохранить',
  common_cancel: 'Отмена',
  common_delete: 'Удалить',
  common_edit: 'Редактировать',
  common_view: 'Просмотр',
  common_search: 'Поиск',
  common_filter: 'Фильтр',
  common_export: 'Экспорт',
  common_import: 'Импорт',
  common_submit: 'Отправить',
  common_close: 'Закрыть',
  common_confirm: 'Подтвердить',
  common_success: 'Успех',
  common_error: 'Ошибка',
  common_warning: 'Предупреждение',
  common_announcement: 'Объявление',

  val_full_name_required: 'Полное имя обязательно',
  val_email_required: 'Электронная почта обязательна',
  val_password_required: 'Пароль обязателен',
  val_password_min: 'Пароль должен содержать минимум 8 символов',
  val_passwords_dont_match: 'Пароли не совпадают',
  security_pin_6_err: 'PIN-код должен состоять ровно из 6 цифр.',
  security_pin_digit_err: 'PIN-код должен содержать только цифры.',
  val_agree_terms: 'Вы должны согласиться с условиями',
  val_conn_error: 'Ошибка подключения. Пожалуйста, попробуйте еще раз.',

  // Homepage
  home_hero_title: 'Зарабатывайте комиссионные от ведущих платформ электронной коммерции',
  home_hero_subtitle: 'Присоединяйтесь к тысячам пользователей, зарабатывающих ежедневные комиссии на Walmart, Alibaba и AliExpress',
  home_get_started: 'Начать прямо сейчас',
  home_learn_more: 'Узнать больше',
  home_how_it_works: 'Как это работает',
  home_features: 'Особенности',
  home_why_choose_us: 'Почему выбирают нас',
  home_features_title: 'Мощные функции',
  home_features_subtitle: 'Все, что вам нужно для начала заработка в интернете. Создано с заботой о вашем успехе.',
  home_commission_tiers: 'Уровни комиссий',
  home_testimonials: 'Что говорят наши пользователи',
  home_faq: 'Часто задаваемые вопросы',
  home_cta_title: 'Готовы начать зарабатывать?',
  home_cta_subtitle: 'Присоединяйтесь к нашему сообществу сегодня и начните зарабатывать комиссионные',
  home_trusted_partner: 'Надежные партнерские платформы',
  home_secure_platform: 'Безопасная платформа',
  home_instant_payouts: 'Мгновенные выплаты',
  home_active_users: 'Активные пользователи',
  home_paid_out: 'Выплачено',
  home_total_paid_out: 'Всего выплачено',
  home_user_rating: 'Рейтинг пользователей',
  home_countries: 'Страны',
  home_commission_badge: 'Потенциал заработка',
  home_commission_title: 'Комиссионные ставки',
  home_commission_desc: 'Более высокий баланс открывает более выгодные комиссионные ставки. Каждая сессия назначает ровно 25 заказов — выполняйте до 4 сессий в день для максимального заработка.',
  home_tier_popular: 'Самый популярный',
  home_tier_commission_per_order: 'Комиссия за заказ',
  home_tier_earn_examples: 'Примеры заработка:',
  home_tier_order: 'заказ',
  home_tier_batch_earn: 'Доход за 25 заказов/партию:',
  home_tier_daily_potential: 'Дневной потенциал (4 партии × 25 заказов)',
  home_tier_max_daily: 'До 100 заказов в день',
  home_tier_benefit_1: '25 заказов за партию',
  home_tier_benefit_2: 'Максимум 4 партии в день',
  home_tier_benefit_3: 'Мгновенное зачисление комиссии',
  home_tier_above: 'Свыше',
  home_tier_no_tiers: 'Уровни комиссий не найдены.',

  // Comparison Section
  home_compare_badge: 'Различие',
  home_compare_title: 'Почему мы лучше',
  home_compare_subtitle: 'Сравните нашу платформу с традиционной подработкой и увидите, почему тысячи выбирают нас.',
  home_compare_feature: 'Особенность',
  home_compare_traditional: 'Традиционная работа',
  home_compare_our_platform: 'Наша платформа',
  home_compare_f1: 'Гибкость',
  home_compare_f1_trad: 'Фиксированный график',
  home_compare_f1_our: 'Работайте в любое время и в любом месте',
  home_compare_f2: 'Выплаты',
  home_compare_f2_trad: 'Ежемесячно или раз в две недели',
  home_compare_f2_our: 'Мгновенно / В тот же день',
  home_compare_f3: 'Требования',
  home_compare_f3_trad: 'Опыт/Резюме/Интервью',
  home_compare_f3_our: 'Нет — только смартфон',
  home_compare_f4: 'Рост',
  home_compare_f4_trad: 'Фиксированное ежегодное повышение',
  home_compare_f4_our: 'Неограниченный рост по уровням',

  // Testimonials
  home_testi_badge: 'Истории успеха',
  home_testi_title: 'Нам доверяют тысячи',
  home_testi_subtitle: 'Послушайте наше глобальное сообщество промоутеров, которые изменили свой доход.',
  home_testi_no_stories: 'Истории успеха пока не доступны.',
  home_testi_total_earned: 'Всего заработано',
  home_testi_time_period: 'Период времени',
  home_testi_verified: 'Верифицированный пользователь',
  home_testi_avg_rating: 'Средний рейтинг',
  home_testi_satisfaction_rate: 'Уровень удовлетворенности',
  home_testi_support_available: 'Доступна поддержка',

  // FAQ
  home_faq_badge: 'Поддержка',
  home_faq_title: 'Частые вопросы',
  home_faq_subtitle: 'Все, что вам нужно знать о том, как начать и зарабатывать.',
  home_faq_no_data: 'Вопросы не найдены.',

  // Trust Bar
  home_trust_badge: 'Глобальное доверие',
  home_trust_title: 'Нам доверяют ведущие бренды',
  home_trust_desc: 'Мы сотрудничаем с крупнейшими в мире платформами электронной коммерции для предоставления проверенных услуг по продвижению.',

  // Feature Section
  feature_1_title: 'Мгновенные выплаты',
  feature_1_desc: 'Получайте вознаграждение сразу после завершения заказа. Выводите средства в любое время без задержек.',
  feature_1_detail_1: 'Зачисление комиссии в реальном времени',
  feature_1_detail_2: 'Несколько вариантов вывода',
  feature_1_detail_3: 'Нет минимального порога',
  feature_2_title: 'Безопасная платформа',
  feature_2_desc: 'Шифрование банковского уровня защищает ваши данные и доходы. Нам доверяют тысячи пользователей по всему миру.',
  feature_2_detail_1: 'Включено SSL-шифрование',
  feature_2_detail_2: 'Двухфакторная аутентификация',
  feature_2_detail_3: 'Регулярные аудиты безопасности',
  feature_2_detail_4: 'Гарантированная конфиденциальность данных',
  feature_3_title: 'Гибкий график',
  feature_3_desc: 'Работайте когда хотите и где хотите. Выполняйте заказы в своем темпе без фиксированного графика.',
  feature_3_detail_1: 'Нет фиксированного рабочего времени',
  feature_3_detail_2: 'Работайте откуда угодно',
  feature_3_detail_3: 'Выбирайте свой темп',
  feature_3_detail_4: 'Доступность в выходные дни',
  feature_4_title: 'Прогрессивный доход',
  feature_4_desc: 'Разблокируйте более высокие комиссионные ставки по мере выполнения заказов. Увеличивайте свой доход с каждым повышением уровня.',
  feature_4_detail_1: 'Комиссионные ставки по уровням',
  feature_4_detail_2: 'Автоматическое повышение уровня',
  feature_4_detail_3: 'Награды за эффективность',
  feature_5_title: 'Глобальная платформа',
  feature_5_desc: 'Работайте с международными брендами из любой точки мира. Включена поддержка нескольких валют.',
  feature_5_detail_1: 'Доступно по всему миру',
  feature_5_detail_2: 'Мультивалютная поддержка',
  feature_5_detail_3: 'Местные способы оплаты',
  feature_6_title: 'Поддержка 24/7',
  feature_6_desc: 'Наша преданная команда поддержки всегда готова помочь. Получите помощь через онлайн-чат, электронную почту или по телефону.',
  feature_6_detail_1: 'Доступен живой чат',
  feature_6_detail_2: 'Поддержка по e-mail 24/7',
  feature_6_detail_3: 'Помощь по телефону',
  feature_6_detail_4: 'Подробный FAQ',
  feature_7_title: 'Реферальная программа',
  feature_7_desc: 'Зарабатывайте дополнительный доход, приглашая друзей. Получайте пожизненные комиссионные от заработка ваших рефералов.',
  feature_7_detail_1: 'Пожизненный доход от рефералов',
  feature_7_detail_2: 'Неограниченное количество рефералов',
  feature_7_detail_3: 'Простые инструменты для обмена',
  feature_7_detail_4: 'Бонусные поощрения',
  feature_8_title: 'Мультивалютность',
  feature_8_desc: 'Поддержка основных валют и способов оплаты. Выберите то, что лучше всего подходит вам.',
  feature_8_detail_1: 'Поддержка USD, EUR, GBP',
  feature_8_detail_2: 'Доступен банковский перевод',
  feature_8_detail_3: 'Интеграция с электронными кошельками',
  feature_8_detail_4: 'Опции криптовалют скоро появятся',
  feature_9_title: 'Мгновенные уведомления',
  feature_9_desc: 'Будьте в курсе событий благодаря оповещениям в режиме реального времени о новых заказах, доходах и активности аккаунта.',
  feature_9_detail_1: 'Push-уведомления',
  feature_9_detail_2: 'Оповещения по e-mail',
  feature_9_detail_3: 'SMS-обновления',
  feature_9_detail_4: 'Сообщения внутри приложения',

  // Home Page Additional Sections
  home_how_it_works_badge: 'Простой процесс',
  home_how_it_works_title: 'Как это работает',
  home_how_it_works_subtitle: 'Начните зарабатывать за 4 простых шага. Опыт не требуется, просто следуйте процессу и наблюдайте за ростом своего дохода.',
  home_cta_ready_title: 'Готовы начать свое путешествие?',
  home_cta_ready_desc: 'Присоединяйтесь к тысячам пользователей, которые уже зарабатывают ежедневно. Ваша первая комиссия всего в нескольких минутах от вас!',
  home_cta_avg_time: 'Среднее время до первого заработка:',
  home_cta_15_mins: '15 минут',
  home_cta_new_users: 'Новых пользователей сегодня:',

  // CTA Section (Premium)
  home_cta_limit_spots: 'В этом месяце количество мест ограничено',
  home_cta_main_title: 'Начните зарабатывать деньги',
  home_cta_today: 'Сегодня!',
  home_cta_main_desc: 'Присоединяйтесь к тысячам пользователей, которые уже получают ежедневные комиссионные. Без опыта, гибкий график, мгновенные выплаты. Ваша финансовая свобода начинается здесь.',
  home_cta_spots_remaining: 'Мест осталось',
  home_cta_new_users_today: 'Новых пользователей сегодня',
  home_cta_create_account: 'Создать бесплатный аккаунт',
  home_cta_sign_in: 'Войти',
  home_cta_secure: '100% безопасно',
  home_cta_payouts: 'Выплаты за 24-48 часов',
  home_cta_rating: 'Рейтинг 4.9/5',
  home_cta_active_users: 'Активные пользователи',
  home_cta_total_paid: 'Всего выплачено',
  home_cta_orders_done: 'Выполненные задачи',
  home_cta_satisfaction: 'Удовлетворенность',
  home_cta_guarantee_title: 'Гарантия возврата денег',
  home_cta_guarantee_desc: 'Не довольны? Получите свой депозит обратно в течение 7 дней',

  // Footer Branding & Extras
  footer_brand_desc: 'Ведущая мировая платформа для продвижения электронной коммерции. Присоединяйтесь к нашей глобальной сети промоутеров сегодня и начните зарабатывать комиссии от ведущих брендов.',
  footer_ssl_secure: 'Защищено SSL',
  footer_aes_256: 'Шифрование AES-256',
  footer_cookie_policy: 'Политика использования файлов cookie',
  footer_disclaimer: 'Отказ от ответственности',
  footer_all_rights: 'Все права защищены.',

  // Announcements
  announcement_withdrawal_delay_title: 'Задержка обработки вывода средств',
  announcement_withdrawal_delay_summary: 'Вывод средств может занять до 72 часов из-за увеличения объема. Пожалуйста, планируйте соответствующим образом.',
  announcement_date_june_14: '14 июня 2025 г.',

  // How It Works Steps
  step_1_title: 'Регистрация',
  step_1_desc: 'Создание аккаунта занимает менее 2 минут.',
  step_1_detail_1: 'Введите свои основные данные',
  step_1_detail_2: 'Подтвердите адрес электронной почты',
  step_1_detail_3: 'Обеспечь게 безопасность аккаунта',
  step_1_detail_4: 'Мгновенный доступ к панели управления',
  step_2_title: 'Выбор задания',
  step_2_desc: 'Выбирайте из доступных заданий по продвижению.',
  step_2_detail_1: 'Фильтр по платформам',
  step_2_detail_2: 'Просмотр комиссионных ставок',
  step_2_detail_3: 'Прием нескольких заданий',
  step_2_detail_4: 'Обновление заданий в реальном времени',
  step_3_title: 'Выполнение задания',
  step_3_desc: 'Выполняйте задания согласно инструкциям.',
  step_3_detail_1: 'Простые инструкции',
  step_3_detail_2: 'Быстрая отправка заданий',
  step_3_detail_3: 'Автоматическая проверка',
  step_3_detail_4: 'Мобильный интерфейс',
  step_4_title: 'Заработок и вывод',
  step_4_desc: 'Получайте оплату за каждое выполненное задание.',
  step_4_detail_1: 'Отслеживание доходов в реальном времени',
  step_4_detail_2: 'Низкий порог вывода средств',
  step_4_detail_3: 'Различные способы оплаты',
  step_4_detail_4: 'Поддержка вывода 24/7',

  // Redesigned Footer
  footer_stay_loop_title: 'Будьте в курсе',
  footer_stay_loop_desc: 'Получайте последние обновления, советы и эксклюзивные предложения прямо на свою почту.',
  footer_subscribe: 'Подписаться',
  footer_subscribe_placeholder: 'Введите ваш адрес электронной почты',
  footer_trusted_secure: 'НАДЕЖНО И БЕЗОПАСНО:',
  footer_ssl_secured: 'SSL Защита',
  footer_ssl_secured_desc: '256-битный SSL',
  footer_aes_encryption: 'AES-256 Шифрование',
  footer_aes_encryption_desc: 'Банковский уровень',
  footer_kyc_compliant: 'KYC Соответствие',
  footer_kyc_compliant_desc: 'Проверено',
  footer_gdpr_compliant: 'GDPR Соответствие',
  footer_gdpr_compliant_desc: 'Данные защищены',
  footer_iso_certified: 'ISO 27001',
  footer_iso_certified_desc: 'Сертифицировано',
  footer_platform: 'ПЛАТФОРМА',
  footer_support: 'ПОДДЕРЖКА',
  footer_legal: 'ЮРИДИЧЕСКАЯ ИНФОРМАЦИЯ',
  footer_help_center: 'Центр помощи',
  footer_contact_us: 'Связаться с нами',
  footer_payments_label: 'Платежи:',
  home_live_activity_title: 'Текущая активность платформы',
  home_recent_activity_title: 'Последние действия',
  home_total_commissions_paid: 'Всего выплачено комиссионных',
  home_active_users_online: 'Активные пользователи онлайн',
  home_tasks_completed_today: 'Задач выполнено сегодня',
  account_security_tips_title: 'Рекомендации по безопасности',
  account_security_tips_desc: 'Улучшите защиту своего аккаунта, следуя этим простым рекомендациям.',
  tip_password_title: 'Надежный пароль',
  tip_password_desc: 'Используйте комбинацию букв, цифр и символов, чтобы обеспечить безопасность вашего аккаунта.',
  tip_two_factor_title: 'Проверка личности',
  tip_two_factor_desc: 'Держите свою контактную информацию в актуальном состоянии, чтобы получать важные уведомления о безопасности.',
  tip_logout_title: 'Регулярный выход',
  tip_logout_desc: 'Всегда выходите из своего аккаунта при использовании общедоступных или общих компьютеров.',
  tip_sharing_title: 'Никогда не передавайте доступ',
  tip_sharing_desc: 'Наша служба поддержки никогда не спросит ваш пароль. Никогда не делитесь своими учетными данными ни с кем.',

  // Запросы на заказ
  order_requests_title: 'Запросы на заказ',
  order_requests_desc: 'Отправьте запрос на новую задачу или индивидуальный заказ. Администратор рассмотрит и назначит задачи на основе вашего запроса.',
  order_requests_new_btn: 'Запросить новый заказ',
  order_requests_table_id: 'ID запроса',
  order_requests_table_data: 'Детали запроса',
  order_requests_table_status: 'Статус',
  order_requests_table_date: 'Отправлено',
  order_requests_table_actions: 'Действия',
  order_requests_cancel: 'Отмена',
  order_requests_cancel_confirm: 'Вы уверены, что хотите отменить этот запрос на заказ?',
  order_requests_cancel_success: 'Запрос на заказ успешно отменен.',
  order_requests_create_success: 'Запрос на заказ успешно отправлен.',
  order_requests_modal_title: 'Отправить новый запрос на заказ',
  order_requests_modal_desc: 'Пожалуйста, предоставьте подробную информацию о заказе, который вы хотите запросить.',
  order_requests_field_data: 'Данные запроса на заказ',
  order_requests_field_placeholder: 'напр.: Я хочу запросить индивидуальный заказ для премиум-пакета.',
  order_requests_btn_submit: 'Отправить запрос',
  order_requests_btn_submitting: 'Отправка...',
  order_requests_empty: 'Запросы на заказ не найдены.',
  order_requests_status_pending: 'В ожидании',
  order_requests_status_approved: 'Одобрено',
  order_requests_status_rejected: 'Отклонено',
  order_requests_status_cancelled: 'Отменено',
  order_requests_terms_title: 'Обязательные условия заказа',
  order_requests_term_1: 'Новые заказы будут назначены в течение 24–48 часов после утверждения.',
  order_requests_term_2: 'После выпуска заказы не могут быть отменены, приостановлены или изменены.',
  order_requests_term_3: 'Все назначенные заказы должны быть завершены до вывода средств.',
  order_requests_term_4: 'Невыполнение заказов может повлиять на статус вашего аккаунта.',
  order_requests_term_5: 'Этот запрос является окончательным и не может быть отменен после подачи.',
  order_requests_policy_title: 'Политика отсутствия отмен',
  order_requests_policy_desc: 'Отправляя этот запрос, вы подтверждаете, что новая партия заказов является окончательной. После подтверждения нашей системой отмена, изменение или возврат средств не допускаются ни при каких обстоятельствах.',
  order_requests_accept_terms: 'Я прочитал и полностью понимаю вышеуказанные условия. Я признаю, что после подачи этот запрос заказа не может быть отменен или изменен, и я соглашаюсь выполнить все назначенные заказы.',

  // Orders Page (New Sections)
  orders_withdrawal_policy: 'Политика вывода средств',
  orders_unlock_req: 'Требования к разблокировке',
  orders_unlock_desc: 'Завершите свою первую партию из {{count}} заказов, чтобы навсегда разблокировать вывод средств. Это разовое требование обеспечивает целостность платформы и предотвращает злоупотребления.',
  orders_daily_limits: 'Ежедневные лимиты заказов',
  orders_daily_limit_1: '{{count}} заказов в партии — вы должны выполнить их все, прежде чем запрашивать следующую партию',
  orders_daily_limit_2: 'Максимум {{count}} партий в день (всего {{total}} заказов в день)',
  orders_comm_rates: 'Комиссионные ставки',
  orders_comm_rates_desc: 'Ставки определяются платформой и вашим текущим балансом кошелька:',
  orders_payout_timeline: 'График выплат',
  orders_payout_desc: 'Вывод средств обрабатывается в течение 24–48 часов. Банковские переводы могут занять 3–5 рабочих дней. Вывод криптовалюты осуществляется мгновенно.',
  orders_processing_fee: 'Комиссия за обработку в размере {{fee}}% применяется ко всем выводам средств для покрытия транзакционных издержек.',
  orders_tips_title: 'Советы для успеха',
  orders_tips_1: 'Выполняйте заказы ежедневно, чтобы набрать темп и максимизировать свой доход',
  orders_tips_2: 'Оставайтесь на странице во время обработки заказа, чтобы обеспечить его правильное завершение',
  orders_tips_3: 'Регулярно проверяйте свой кошелек, чтобы отслеживать рост комиссионных',
  orders_tips_4: 'Приглашайте друзей, чтобы получать бонусные комиссии с их заказов',
  orders_tips_5: 'При возникновении проблем немедленно свяжитесь с поддержкой',
  orders_batch_approx: '{{count}} заказов в партии × среднее ${{avg}} = примерно ${{total}} за партию',

  // Settings
  settings_page_title: 'Настройки',
  settings_page_desc: 'Управляйте своей безопасностью, конфиденциальностью и предпочтениями',
  settings_kyc_label: 'Проверка KYC',
  settings_kyc_desc: 'Верификация личности',
  settings_security_label: 'Безопасность',
  settings_security_desc: 'Управление паролями',
  settings_language_label: 'Язык',
  settings_language_desc: 'Региональные настройки',

  // Support
  support_btn_send: 'Отправить ответ',
  support_edit_message: 'Редактировать сообщение',
  support_delete_message: 'Удалить сообщение',
  support_delete_confirm: 'Вы уверены, что хотите удалить это сообщение?',
  support_message_updated: 'Сообщение успешно обновлено',
  support_message_deleted: 'Сообщение успешно удалено',
  support_err_already_read: 'Невозможно отредактировать сообщение после того, как оно было просмотрено.',
  support_status_read: 'Просмотрено',
  support_status_unread: 'Отправлено',
  // Модальное окно депозита
  deposit_modal_title_method: "Выберите способ оплаты",
  deposit_modal_title_gateway: "Выберите криптокошелек",
  deposit_modal_title_plan: "Выберите план депозита",
  deposit_modal_title_details: "Детали депозита",
  deposit_modal_step_method: "Метод",
  deposit_modal_step_gateway: "Кошелек",
  deposit_modal_step_plan: "План",
  deposit_modal_step_details: "Детали",
  deposit_modal_credit_card: "Кредитная / дебетовая карта",
  deposit_modal_bank_transfer: "Банковский перевод",
  deposit_modal_ewallet: "Электронный кошелек",
  deposit_modal_digital_currency: "Цифровая валюта",
  deposit_modal_not_available: "Недоступно в вашем регионе",
  deposit_modal_available_recommended: "Доступно — Рекомендуется",
  deposit_modal_back_to_method: "Вернуться к способам оплаты",
  deposit_modal_back_to_gateway: "Вернуться к списку кошельков",
  deposit_modal_back_to_plan: "Вернуться к планам",
  deposit_modal_digital_selected: "Цифровая валюта выбрана",
  deposit_modal_digital_hint: "Выберите криптокошелек, чтобы получить адрес и инструкции.",
  deposit_modal_loading_wallets: "Загрузка кошельков...",
  deposit_modal_no_wallets: "Нет доступных криптокошельков.",
  deposit_modal_loading_plans: "Загрузка планов...",
  deposit_modal_no_plans: "На данный момент нет доступных планов депозита.",
  deposit_modal_duration: "Продолжительность",
  deposit_modal_amounts_profits: "Суммы и прибыль",
  deposit_modal_amount_label: "Сумма",
  deposit_modal_profit_label: "Прибыль",
  deposit_modal_benefits: "Преимущества",
  deposit_modal_continue: "Продолжить",
  deposit_modal_transfer_details: "Детали перевода для {{name}}",
  deposit_modal_deposit_amount: "Сумма депозита",
  deposit_modal_amount_fixed: "Сумма фиксирована вашим выбранным планом",
  deposit_modal_txn_id: "ID транзакции",
  deposit_modal_txn_optional: "(Опционально)",
  deposit_modal_txn_placeholder: "например, 0x1a2b3c4d...",
  deposit_modal_screenshot: "Скриншот",
  deposit_modal_upload_proof: "Загрузить подтверждение оплаты",
  deposit_modal_upload_hint: "PNG, JPG, JPEG — Макс. 5 МБ",
  deposit_modal_comments: "Комментарии",
  deposit_modal_comments_placeholder: "Любая дополнительная информация...",
  deposit_modal_notice: "После отправки наша команда проверит ваш платеж и зачислит средства на ваш счет в течение 5–30 минут.",
  deposit_modal_confirm: "Подтвердить депозит",
  deposit_modal_submitting: "Отправка...",
  deposit_modal_err_fields: "Пожалуйста, заполните все обязательные поля",
  deposit_modal_err_submit: "При отправке произошла ошибка",
  deposit_modal_success: "Депозит успешно запрошен!",
  deposit_modal_err_plans: "Не удалось загрузить планы депозита",
  deposit_modal_err_wallets: "Не удалось загрузить способы оплаты",
  deposit_modal_new_to_crypto: "New to crypto? Learn how to buy digital currency",
  deposit_modal_crypto_label: "Крипто",
  orders_insufficient_balance: "Insufficient Balance",
  orders_balance_gap_msg1: "Your current balance is not enough to complete this order.",
  orders_balance_gap_msg2_start: "Please add",
  orders_balance_gap_msg2_end: "to proceed and unlock your commission.",
  orders_btn_add_funds: "Add Funds",
  withdrawal_restricted_support: "Contact Support",
  deposit_modal_plan_description_hint: "Add the deposit for getting the order and earn the commission from order process",
};
